import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import likeunlike from "@/components/tools/likeunlike.vue";
import { PageType } from "@/globalcfg";
export default {
  data() {
    return {
      loading: false,
      loadingText: "Loading model...",
      showHint: true,
      // 页面类型，如果是MainHome就不能显示
      PageType: PageType,
      pageshow: false,
      isReleasing: false,
      // 添加发布状态跟踪变量
      isDeleting: false // 添加删除状态跟踪变量
    };
  },

  components: {
    likeunlike
  },
  emits: ["onHandleBuild", "onClicklike"],
  props: {
    previewImg: {
      Type: Image
    },
    currentimgInfo: {
      //当前选中的像素画数据
      Type: Object
    }
  },
  watch: {
    previewImg: {
      handler: function (val, oldVal) {},
      deep: true
    }
  },
  mounted() {
    if (this.PageType == "MainHome") {
      this.pageshow = false;
    } else if (this.PageType == "ContentMaker") {
      this.pageshow = true;
    }
  },
  methods: {
    onClicklike(imginfo) {
      // console.log("model show onClicklike");

      this.$emit("onClicklike", imginfo);
    },
    // 下载ldr模型
    onDownload() {
      let ldrname = this.currentimgInfo.ldrname;
      let url = '/imageprocesshost' + '/ldr/' + ldrname;

      // 创建a标签
      const link = document.createElement('a');

      // 给a标签添加属性
      link.href = url;

      // 设置下载的文件名，默认是'下载'
      link.download = ldrname;

      // 将a标签插入到body中
      document.body.appendChild(link);

      // 模拟点击
      link.click();
    },
    // 下载生成图
    async onDownloadImage() {
      const imgname = this.currentimgInfo.id;
      // 加上时间戳，避免 Chrome 恢复/缓存导致的偶发下载失败
      const url = '/imageprocesshost' + '/hd-image/' + `?hdimageid=${encodeURIComponent(imgname)}&t=${Date.now()}`;
      console.log('下载生成图url=', url);
      try {
        // 优先使用 fetch -> blob 的方式，更稳定且可携带凭据
        await this.downloadFile(url, imgname + '.jpg');
        // 可选提示
        if (this.$notify) this.$notify({
          type: 'success',
          message: '开始下载'
        });
      } catch (err) {
        console.error('下载生成图失败，回退到直接链接方式', err);

        // 回退到旧逻辑，尽量不影响用户
        const link = document.createElement('a');
        link.href = url;
        link.download = imgname;
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    },
    // 通用下载方法：fetch -> blob -> a[download]
    async downloadFile(url, suggestedFilename) {
      const res = await fetch(url, {
        // 如果后端依赖 Cookie/Session，确保附带凭据
        credentials: 'include',
        // 强制不走缓存，规避断点/缓存导致的“网络失败”
        cache: 'no-store'
      });
      if (!res.ok) {
        throw new Error(`HTTP ${res.status}`);
      }
      const blob = await res.blob();

      // 优先使用服务器返回的文件名
      const disposition = res.headers.get('content-disposition');
      const serverFilename = this.getFilenameFromDisposition(disposition);
      const filename = serverFilename || suggestedFilename || 'download';
      const blobUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(blobUrl);
    },
    // 解析 Content-Disposition 中的文件名
    getFilenameFromDisposition(header) {
      if (!header) return null;
      // 同时兼容 filename 和 filename*（RFC 5987）
      const match = /filename\*?=(?:UTF-8''|\")?([^\";]+)/i.exec(header);
      if (match && match[1]) {
        const raw = match[1].replace(/[\'\"]/g, '');
        try {
          return decodeURIComponent(raw);
        } catch (_) {
          return raw;
        }
      }
      return null;
    },
    // 下载拼装json
    onDownloadJSON() {
      let imgname = this.currentimgInfo.id;
      let url = '/imageprocesshost' + '/hd-image/' + '?assembleid=' + imgname;

      // 创建a标签
      const link = document.createElement('a');

      // 给a标签添加属性
      link.href = url;

      // 设置下载的文件名，默认是'下载'
      link.download = imgname;

      // 将a标签插入到body中
      document.body.appendChild(link);

      // 模拟点击
      link.click();
    },
    // 发布为首页滚动图
    // 这个按钮将会通知后台，根据当前选择的图片，找到对应的json拼装文件，再动态生成pdf文件，最好保存到对应的目录下，完成发布的一整套流程
    async onReleaseInHomePage() {
      this.isReleasing = true; // 开始发布，按钮变为不可点击状态

      let imgname = this.currentimgInfo.id;
      let url = '/imageprocesshost' + '/release2main/' + '?assembleid=' + imgname;

      // 发送请求
      try {
        const response = await fetch(url);
        const data = await response.json();
        console.log(data);
        this.$notify({
          type: 'success',
          message: '发布成功'
        });
      } catch (error) {
        console.log("发布失败");
        this.$notify({
          type: 'danger',
          message: '发布失败'
        });
      } finally {
        this.isReleasing = false; // 无论成功或失败，恢复按钮可点击状态
      }
    },

    // 从首页删除
    async onDeletInHomePage() {
      this.isDeleting = true; // 开始发布，按钮变为不可点击状态

      let imgname = this.currentimgInfo.id;
      let url = '/imageprocesshost' + '/deletefrommain/' + '?assembleid=' + imgname;

      // 发送请求
      try {
        const response = await fetch(url);
        const data = await response.json();
        console.log(data);
        this.$notify({
          type: 'success',
          message: '删除成功'
        });
      } catch (error) {
        console.log("删除失败");
        this.$notify({
          type: 'danger',
          message: '删除失败'
        });
      } finally {
        this.isDeleting = false; // 无论成功或失败，恢复按钮可点击状态
      }
    }
  }
};